import confetti, { type Options as ConfettiOptions } from 'canvas-confetti';

/**
 * Pops celebration confetti from both bottom corners of the screen.
 * Respects the user's prefers-reduced-motion accessibility setting.
 */
export const popConfettiOnScreen = (): void => {
	const isReduceMotion = globalThis.window
		? matchMedia('(prefers-reduced-motion: reduce)').matches
		: false;

	const baseProps: ConfettiOptions = {
		particleCount: 120,
		zIndex: 2000,
		scalar: 1.2,
		startVelocity: 70,
		colors: ['#FCA700', '#AF59E1', '#1868DB', '#6A9A23'],
		disableForReducedMotion: isReduceMotion,
	};

	// Left corner
	void confetti({
		...baseProps,
		origin: {
			x: -0.15,
			y: 0.15,
		},
		angle: 0,
	});

	// Right corner
	void confetti({
		...baseProps,
		origin: {
			x: 1.15,
			y: 0.15,
		},
		angle: 180,
	});
};
